/**
 * What an admin screen shows when a save fails. Every admin PUT is validated by the service, and a refusal carries a
 * sentence naming the field or the limit ("houseRules: Too big: expected string to have <=8000 characters"); the
 * screens used to drop it, so the spinner stopped and the admin believed the change was saved.
 */
export function errorText(error: unknown, fallback: string): string {
  return error instanceof Error && error.message.trim() ? error.message : fallback;
}

/** A feature-flag rollout percentage the service accepts: a whole number from 0 to 100 (it refuses anything else). */
export function clampPercent(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.min(100, Math.max(0, Math.round(value)));
}

/** The persona field lengths the service accepts (gyro-svc adminSchema.ts personaSchema). */
export const PERSONA_LIMITS = { name: 80, greeting: 600, houseRules: 8000 } as const;
